export default __webpack_public_path__ + "media/zurb/img/icons/arrow-774aa0cd61b05763e979f724ab929c54.svg";